import React from "react"

import { Avatar } from "@coval/ui"

import type { Speaker } from "./messageSpeaker"

interface MessageHeaderProps {
  speaker: Speaker
  className?: string
  agentLabel?: string
  userLabel?: string
  /** The organization's image. Falls back to initials from `agentLabel`. */
  agentAvatarUrl?: string
  /** The persona's face. Falls back to initials from `userLabel`. */
  userAvatarUrl?: string
  agentAvatarTint?: string
  userAvatarTint?: string
}

export const MessageHeader: React.FC<MessageHeaderProps> = ({
  speaker,
  className = "",
  agentLabel = "My Agent",
  userLabel = "Coval",
  agentAvatarUrl,
  userAvatarUrl,
  agentAvatarTint,
  userAvatarTint,
}) => {
  const isPersona = speaker === "persona"
  const displayRole = isPersona ? userLabel : agentLabel
  const avatarUrl = isPersona ? userAvatarUrl : agentAvatarUrl
  const avatarTint = isPersona ? userAvatarTint : agentAvatarTint

  return (
    <div className={`flex min-w-0 items-center gap-1.5 ${className}`}>
      <Avatar
        size="sm"
        name={displayRole}
        src={avatarUrl}
        tint={avatarTint}
        decorative
      />
      <span className="truncate text-xs capitalize">{displayRole}</span>
    </div>
  )
}
